import { apiGet, apiPost } from './api';

export interface User {
  id: string;
  email: string;
  name: string;
  role: 'ADMIN' | 'ORGANIZER' | 'STAFF' | 'READONLY';
  organizationId: string;
  organization?: {
    id: string;
    name: string;
    defaultLanguage: string;
    brandingLogoUrl: string | null;
  };
  lastLoginAt: string | null;
  pictureUrl?: string | null;
  language?: 'de' | 'en' | null;
}

export interface AuthResponse {
  user: User;
  accessToken: string;
  isNew: boolean;
}

export async function loginWithGoogle(
  idToken: string,
  organizationId?: string
): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/auth/google', { idToken, organizationId });
}

export async function getCurrentUser(): Promise<User> {
  return apiGet<User>('/auth/me');
}

export async function refreshToken(): Promise<{ accessToken: string }> {
  return apiPost<{ accessToken: string }>('/auth/refresh');
}

export async function logout(): Promise<void> {
  await apiPost('/auth/logout');
}

// Development-only login
export async function devLogin(
  email: string,
  name?: string,
  role?: 'ADMIN' | 'ORGANIZER' | 'STAFF' | 'READONLY'
): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/auth/dev-login', { email, name, role });
}
